<template>
  <div>
    <md-card>

      <md-card-header>
        <h4>Archivos de siniestro</h4>
      </md-card-header>

      <md-card-content class="md-layout md-gutter">

        <md-card class="md-layout-item md-size-100">
          <md-card-header> <h4>Factura</h4> </md-card-header>
          <md-card-content>
            
            <md-table>
              <md-table-row>
                <md-table-head> Folio </md-table-head>
                <md-table-head> total </md-table-head>
                <md-table-head> UUID </md-table-head>
                <md-table-head> PDF </md-table-head>
                <md-table-head> XML </md-table-head>
              </md-table-row>
              <md-table-row>
                <md-table-cell> {{ taxReceip.folio }} </md-table-cell>
                <md-table-cell> {{ taxReceip.total }} </md-table-cell>
                <md-table-cell> {{ taxReceip.uuid }} </md-table-cell>
                <md-table-cell>
                  <md-button class="md-success md-just-icon md-round" @click="downloadItem(taxReceip.pdfFile)">
                    <md-icon>pageview</md-icon>
                  </md-button>
                </md-table-cell>
                <md-table-cell>
                  <md-button class="md-success md-just-icon md-round" @click="downloadItem(taxReceip.xmlFile)">
                    <md-icon>cloud_download</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>

          </md-card-content>
        </md-card>

        <md-card v-for="(file, index) in files" :key="index" class="md-layout-item md-size-33">
          
          <md-card-header>
            <div class="md-layout md-gutter">
              <h3 class="md-layout-item md-size-80"> {{ file.name }} </h3>

              <div style="margin-top: 1em">
                <md-button class="md-success md-just-icon md-round" @click="showFile(file)">
                  <md-icon>remove_red_eye</md-icon>
                </md-button>
              </div>
            </div>
          </md-card-header>

          <md-card-content>
            <p> {{ file.description }} </p>
          </md-card-content>

        </md-card>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>

import { assetURL } from '@/utils'

export default {
  name: 'FilesView',
  props: {
    files: Array,
    taxReceip: Object
  },
  data () {
    return {}
  },
  methods: {
    showFile (file) {
      window.open(assetURL(file.file), name='_blank')
    },
    downloadItem (item) {
      window.open(item, name='_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/extranet/FilesView.vue